import {FETCH_ALL_CATEGORIES} from '../actions';

export default function (state={}, action){
  switch (action.type) {
    case FETCH_ALL_CATEGORIES:
      return action.payload.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_catagoryList.js